// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import type { AttractiveScoreType, CoqueRetailer } from '../../../../../types/apolloType';
import AttractiveScoreRadarChart from './AttractiveScoreRadarChart';
import TrendinessComponent from './TrendinessComponent';
import ScarcityComponent from './ScarcityComponent';
import DifferentiationComponent from './DifferentiationComponent';
import AttractiveScoreDimensionWrapper from './AttractiveScoreDimensionWrapper';
import { roundValue } from '../../../../../utils/formatUtils';
import Loader from '../../../../common/Loader';
import retailerApi from '../../../../../network/api/retailerApi';

type Props = {
  currentRetailer: CoqueRetailer,
};

type State = {
  attractiveScore: AttractiveScoreType,
  isAttractiveScoreLoading: boolean,
}

class AttractiveScore extends React.Component<Props, State> {
  state = {
    attractiveScore: {},
    isAttractiveScoreLoading: true,
  };

  componentDidMount() {
    this.fetchGoodwill(this.props.currentRetailer);
  }

  shouldComponentUpdate(nextProps: Props, nextState: State, nextContext: any): boolean {
    if (this.props.currentRetailer.codeRetailerProposition !== nextProps.currentRetailer.codeRetailerProposition) {
      this.fetchGoodwill(nextProps.currentRetailer);
    }

    return true;
  }

  fetchGoodwill = (currentRetailer: CoqueRetailer) => {
    this.setState({ isAttractiveScoreLoading: true });

    retailerApi.fetchAttractiveScoreByRetailerId(currentRetailer.codeRetailerProposition)
      .then(response => response.json())
      .then(response => this.setState({ attractiveScore: response }))
      .catch(() => this.setState({ attractiveScore: null }))
      .finally(() => this.setState({ isAttractiveScoreLoading: false }));
  }

  render() {
    const { attractiveScore, isAttractiveScoreLoading } = this.state;
    return (
      <div className="attractive-score">
        <div className="attractive-score-header">
          <div className="store-score">
            <Translate
              value="attractiveScore.store_score"
              storeName={this.props.currentRetailer.retailerName}
            />
            <div className="score">
              {
                attractiveScore ? (
                  <Translate
                    value="attractiveScore.score"
                    score={roundValue(attractiveScore.attractiveScore)}
                  />
                ) : (
                  <Translate value="attractiveScore.no_data" />
                )
              }
            </div>
          </div>
          <div className="attractive-score-subtitle"><Translate value="attractiveScore.subtitle" /></div>
          <div className="attractive-score-explanation"><Translate value="attractiveScore.explanation" /></div>
          {
            isAttractiveScoreLoading
              ? (
                <Loader isLoading />
              ) : (
                <AttractiveScoreRadarChart
                  scarcityNote={attractiveScore && attractiveScore.scarcity.note}
                  uniquenessNote={attractiveScore && attractiveScore.uniqueness.note}
                  trendinessNote={attractiveScore && attractiveScore.trendiness.note}
                />
              )
          }
        </div>
        {
          !isAttractiveScoreLoading && attractiveScore && (
            <div className="attractive-dimensions-container">
              <AttractiveScoreDimensionWrapper
                isAttractiveScoreLoading={isAttractiveScoreLoading}
                i18nPath="attractiveScore.scarcity"
                score={roundValue(attractiveScore.scarcity.note)}
              >
                <ScarcityComponent scarcity={attractiveScore.scarcity} />
              </AttractiveScoreDimensionWrapper>
              <AttractiveScoreDimensionWrapper
                isAttractiveScoreLoading={isAttractiveScoreLoading}
                i18nPath="attractiveScore.differentiation"
                score={roundValue(attractiveScore.uniqueness.note)}
              >
                <DifferentiationComponent uniqueness={attractiveScore.uniqueness} />
              </AttractiveScoreDimensionWrapper>
              <AttractiveScoreDimensionWrapper
                isAttractiveScoreLoading={isAttractiveScoreLoading}
                i18nPath="attractiveScore.trendiness"
                score={roundValue(attractiveScore.trendiness.note)}
              >
                <TrendinessComponent trendiness={attractiveScore.trendiness} />
              </AttractiveScoreDimensionWrapper>
            </div>
          )
        }
      </div>
    );
  }
}

export default AttractiveScore;
